module.exports = __webpack_public_path__ + "assets/img/1.820f4d81.png";